module.exports = __webpack_public_path__ + "img/组 9.663a832a.png";